import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import { DataSetHistoryModel } from '~/shared/model/Dataset/DataSetHistoryModel'
import { MainStore } from '~/store/index'

@Module({ namespaced: true, name: 'DataSetModule', dynamic: true, store: MainStore })
export default class DataSetModule extends VuexModule {
    datasetHistory: Array<DataSetHistoryModel> = [] as Array<DataSetHistoryModel>
    selectedCommonConceptId:number = 0
    selectedCommonConceptName:string=' '

    get getSelectedCCName () {
      return this.selectedCommonConceptName
    }

    get getDatasetHistory () {
      return this.datasetHistory
    }

    @Mutation
    AddSearechTermToDatasetHistory (dataset:DataSetHistoryModel) {
      dataset.commonConceptId = Number(dataset.commonConceptId)
      // console.log(dataset)
      // console.log(this.datasetHistory)
      const studyHistoryIds = this.datasetHistory.map(sh => sh.commonConceptId)
      if (studyHistoryIds.includes(dataset.commonConceptId)) {
        console.log('exists')
        const index = studyHistoryIds.indexOf(dataset.commonConceptId)
        this.datasetHistory.splice(index, 1)
      }
      this.datasetHistory.unshift(dataset)
      // console.log(this.datasetHistory)
    }

    @Mutation
    SetSelectedCCId (id:number) {
      this.selectedCommonConceptId = id
    }

    @Mutation
    SetSelectedCCName (name:string) {
      this.selectedCommonConceptName = name
    }

    @Action
    updateDatasetHistory (dataset: DataSetHistoryModel) {
      this.AddSearechTermToDatasetHistory(dataset)
    }
}
